import { trackEvent as t } from '../track';
import { MetadataAppType } from './propertyTypes';

interface DisconnectAppProps {
  '[Metadata] App type': MetadataAppType,
}

export const organization = {
  changePermission: () => t('[Organization] Change user permissions'),
  create: () => t('[Organization] Create'),
  disconnectApp: (props: DisconnectAppProps) => t('[Organization] Disconnect organization app', props),
  removeUser: () => t('[Organization] Remove user'),
};
